// API
import { getEnvVar } from './utils/env';

export const HOST_API_KEY = getEnvVar('VITE_HOST_API_KEY');
export const BACKEND_URL = getEnvVar('VITE_BACKEND_URL');
export const APPLICATIONINSIGHTS_CONNECTION_STRING = getEnvVar(
  'VITE_APPLICATIONINSIGHTS_CONNECTION_STRING'
);
export const APP_REGISTRATION_CLIENT_ID = getEnvVar('VITE_APP_REGISTRATION_CLIENT_ID');
export const TENANT_ID = getEnvVar('VITE_TENANT_ID');
export const REDIRECT_URI = getEnvVar('VITE_REDIRECT_URI');
export const KEYCLOAK_URL = getEnvVar('VITE_KEYCLOAK_URL');
export const KEYCLOAK_REALM = getEnvVar('VITE_KEYCLOAK_REALM');
export const KEYCLOAK_CLIENT_ID = getEnvVar('VITE_KEYCLOAK_CLIENT_ID');

export const SCENARIO_REDIRECT = getEnvVar('VITE_SCENARIO_REDIRECT');
export const SCENARIO_UPLOAD = getEnvVar('VITE_SCENARIO_UPLOAD');
export const ASSETS_UPLOAD = getEnvVar('VITE_ASSESTS_UPLOAD');

if (!BACKEND_URL) {
  throw new Error('Environment variable VITE_BACKEND_URL must be set.');
}

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const SEARCH_BAR = {
  H_SEARCH_DESKTOP: 104,
};

export const FOOTER = {
  H_MAIN_DESKTOP: 72,
};

export const NAV = {
  W_BASE: 260,
  W_LARGE: 320,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

export const PAGINATION_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 50, 100, 200];
export const PAGINATION_ROWS_PER_PAGE_DEFAULT = 200;
